import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, renderSlot as _renderSlot, mergeProps as _mergeProps, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { computed } from "vue";
import CloudButton from "@/components/CloudButton/index.vue";
import { useCounterStore } from "@/store/user";
export default /*#__PURE__*/ _defineComponent({
    name: 'index',
    props: {
        type: { default: "" },
        size: { default: "" },
        icon: { default: "" },
        border: { type: Boolean, default: true },
        text: { type: Boolean, default: false },
        disabled: { type: Boolean, default: false },
        rawContent: { type: Boolean, default: false },
        loading: { type: Boolean, default: false },
        noPadding: { type: Boolean, default: false },
        checkAuth: { type: Boolean, default: true },
        tips: { default: "" },
        onClick: null
    },
    emits: ["click"],
    setup(__props, { emit: emits }) {
        const props = __props;
        const userStore = useCounterStore();
        const userType = userStore.getUserInfo.type;
        const hasPermission = computed(() => {
            if (!props.checkAuth) {
                return true;
            }
            return userType !== "sub";
        });
        const clickHandle = () => {
            emits("click");
        };
        return (_ctx, _cache) => {
            const _component_el_tooltip = _resolveComponent("el-tooltip");
            return (_openBlock(), _createBlock(_component_el_tooltip, {
                effect: "dark",
                "raw-content": __props.rawContent,
                content: !_unref(hasPermission) ? '子用户不支持该操作' : __props.tips,
                placement: "top",
                disabled: _unref(hasPermission) && __props.tips === ''
            }, {
                default: _withCtx(() => [
                    _createVNode(CloudButton, _mergeProps(_ctx.$attrs, {
                        disabled: __props.disabled || !_unref(hasPermission),
                        icon: __props.icon,
                        border: __props.border,
                        size: __props.size,
                        text: __props.text,
                        type: __props.type,
                        loading: __props.loading,
                        onClick: clickHandle
                    }), {
                        default: _withCtx(() => [
                            _renderSlot(_ctx.$slots, "default")
                        ]),
                        _: 3
                    }, 16, ["disabled", "icon", "border", "size", "text", "type", "loading"])
                ]),
                _: 3
            }, 8, ["raw-content", "content", "disabled"]));
        };
    }
});
